import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { IModelClassDto } from '~/models/modules/Asset/modelClass';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class ModelClassService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }
  getModelClassById(id:number){
    return this.client.get<IModelClassDto>(this._url(`/${id}`))
  }
  getModelClassListing(){
    return this.http.get<IModelClassDto[]>(this._url());
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/ModelClass${v}`);
  }
}
